import type { NextLink, Operation } from '@apollo/client';
import { omitDeep } from '@app/global/utils/omitDeep';

export const omitTypenameLink = (operation: Operation, forward: NextLink) => {
  if (operation.variables) {
    operation.variables = omitDeep(operation.variables, ['__typename']);
  }
  return forward(operation);
};
